export default __webpack_public_path__ + "static/media/gallery_07.436a1663.jpg";